module.exports = __webpack_public_path__ + "static/img/floor3-lz4.287f424.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dh-map/floor3-lz4.png
// module id = Uo6c
// module chunks = 1